import * as types from './mutation-types'

export default {
  [types.ADD_DGI_TAXES](state, data) {
    state.dgiTaxes = data.dgi_taxes
  },
}
